import actionTypes from 'redux/actions/actionTypes'
import lessonCreationLocation from 'helpers/enums/metrics/lessonCreationLocation'

const lessonTypes = {
	SLIDE: 'Slide',
	GOOGLE_SLIDES: 'Google Slides',
	VIDEO: 'Video',
}

const LESSON_CREATION_ACTION_TYPES = {
	[actionTypes.MAIN_TOPBAR_CREATE_LESSON]:
		{ Location: lessonCreationLocation.HEADER, Type: lessonTypes.SLIDE },
	[actionTypes.MAIN_TOPBAR_CREATE_GOOGLE_DRIVE_LESSON]:
		{ Location: lessonCreationLocation.HEADER, Type: lessonTypes.GOOGLE_SLIDES },
	[actionTypes.MAIN_TOPBAR_CREATE_INTERACTIVE_VIDEO]:
		{ Location: lessonCreationLocation.HEADER, Type: lessonTypes.VIDEO },
	[actionTypes.MY_LIBRARY_CREATE_LESSON]:
		{ Location: lessonCreationLocation.MY_LIBRARY, Type: lessonTypes.SLIDE },
	[actionTypes.MY_LIBRARY_CREATE_GOOGLE_DRIVE_LESSON]:
		{ Location: lessonCreationLocation.MY_LIBRARY, Type: lessonTypes.GOOGLE_SLIDES },
	[actionTypes.MY_LIBRARY_CREATE_INTERACTIVE_VIDEO]:
		{ Location: lessonCreationLocation.MY_LIBRARY, Type: lessonTypes.VIDEO },
	[actionTypes.ONBOARDING_GUIDE_LESSON_BUILDER_CARD_SELECTED]:
		{ Location: lessonCreationLocation.ONBOARDING_GUIDE, Type: lessonTypes.SLIDE },
	[actionTypes.MY_LIBRARY_CREATE_LESSON_THUMBNAIL]:
		{ Location: lessonCreationLocation.THUMBNAIL, Type: lessonTypes.SLIDE },
}

export default actionType => LESSON_CREATION_ACTION_TYPES[actionType]
	? LESSON_CREATION_ACTION_TYPES[actionType]
	: {}
